import React, { Component } from 'react';
import { Form, FieldArray, withFormik } from 'formik';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import * as Yup from 'yup';
import AddIcon from './add.svg';
import { Input as FormInput } from '../../Form/index';
import { Button } from '../../Button';
import {
  withInputClassNames,
  withTextAreaClassNames,
} from './../../EditProfile/HOC';
import './WorkExperiencesCard.css';

const Input = withInputClassNames(FormInput);
const TextArea = withTextAreaClassNames(FormInput);

const addAsyncEmptyForm = (
  arrayHelpers,
  values,
  handleAddAnotherExperience,
) => {
  if (!handleAddAnotherExperience) return;
  handleAddAnotherExperience(values).then(() => {
    arrayHelpers.push({
      company_name: '',
      job_title: '',
      job_description: '',
    });
  });
};

class WorkExperiencesCard extends Component {
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.values, this.props.values)) {
      this.send();
    }
  }

  componentDidMount() {
    if (!this.props.isValid) {
      this.props.handleInputChange({ errors: { error: true } });
    }
  }

  send = debounce(() => {
    const { values, errors } = this.props;
    this.props.handleInputChange({ values, errors });
  }, 300);

  renderForm = experiences =>
    experiences.map((experience, index) => (
      <div key={String(index)}>
        {index > 0 && <hr className="my-5" />}
        <Input
          label="Company"
          className="form-control"
          name={`experiences.${index}.company_name`}
        />
        <Input
          label="Job Title"
          className="form-control"
          name={`experiences.${index}.job_title`}
        />
        <TextArea
          label="Job Description"
          className="form-control"
          name={`experiences.${index}.job_description`}
        />
      </div>
    ));

  render() {
    const { values, isValid, handleAddAnotherExperience } = this.props;
    return (
      <div className="col-12 col-lg-10 offset-lg-1">
        <div className="bg-white shadow-card p-5">
          <Form className="experiences-card__form">
            <FieldArray
              name="experiences"
              render={arrayHelpers => (
                <div>
                  {values.experiences &&
                    values.experiences.length > 0 &&
                    this.renderForm(values.experiences)}
                  <Button
                    className="mx-3 experiences-card__add-another-experiences-button"
                    textClassName="experiences-card__add-another-experiences-button-text"
                    leftIcon={AddIcon}
                    title="Add another experience"
                    onClick={() =>
                      addAsyncEmptyForm(
                        arrayHelpers,
                        values,
                        handleAddAnotherExperience,
                      )
                    }
                    disabled={!isValid}
                    transparent
                    withoutTextTransform
                  />
                </div>
              )}
            />
          </Form>
        </div>
      </div>
    );
  }
}

WorkExperiencesCard.propTypes = {
  errors: PropTypes.object,
  handleInputChange: PropTypes.func,
  handleAddAnotherExperience: PropTypes.func,
  values: PropTypes.shape({
    experiences: PropTypes.array,
  }),
  isValid: PropTypes.bool,
};

const experiencesInitialValues = [
  {
    company_name: '',
    job_title: '',
    job_description: '',
  },
];

const mapPropsToValues = props => ({
  experiences: !isEmpty(props.experiences)
    ? props.experiences
    : experiencesInitialValues,
});

const validationSchema = Yup.object().shape({
  experiences: Yup.array().of(
    Yup.object().shape({
      job_title: Yup.string().required('Job title is required'),
      job_description: Yup.string().required('Job description is required'),
    }),
  ),
});

export default withFormik({
  enableReinitialize: true,
  validateOnBlur: true,
  validateOnChange: true,
  isInitialValid: props =>
    validationSchema.isValidSync(mapPropsToValues(props)),
  mapPropsToValues,
  validationSchema,
  displayName: 'ExperiencesCardForm',
})(WorkExperiencesCard);



// WEBPACK FOOTER //
// ./src/components/FreelancerPortfolio/WorkExperienceCard/WorkExperiencesCard.js